import React from 'react';

import { convertMargin, convertPadding } from '../../utils/paddings';
import { slugify } from '../../utils/slugify';
import { isRunTime } from 'src/utils/isRunTime';
import { getImageDeliveryUrl } from "src/utils/imageDelivery";


type ModulePaddings = {
  top: 'none' | 'small' | 'medium' | 'large' | undefined;
  bottom: 'none' | 'small' | 'medium' | 'large' | undefined;
}

type ModuleWrapperProps = {
  name: string | undefined;
  anchor: string | undefined;
  paddings: ModulePaddings | undefined;
  className: string | undefined;
  backgroundColor: string | undefined;
  overlayColor?: string | undefined;
  backgroundImage?: string | undefined;
  mobileBackgroundImage?: String | undefined;
  roundedCorners: boolean;
  children: React.ReactNode | undefined;
  style?: React.CSSProperties & TCSSVars;
  isFullWidth?: boolean;
  ariaLabel?: string | undefined;
}

export class ModuleWrapperV2 extends React.Component<ModuleWrapperProps> {

  static defaultProps = {
    className: "",
    isFullWidth: true
  }
  //FLM-5955-> now directus paddings will work as margins when module is boxed.
  get padding_top() {
    const { isFullWidth } = this.props;
    if (isFullWidth) return convertPadding(this.props.paddings?.top || 'none', 'top');
    return convertMargin(this.props.paddings?.top || 'none', 'top');
  }
  //FLM-5955-> now directus paddings will work as margins when module is boxed.
  get padding_bottom() {
    const { isFullWidth } = this.props;
    if (isFullWidth) return convertPadding(this.props.paddings?.bottom || 'none', 'bottom');
    return convertMargin(this.props.paddings?.bottom || 'none', 'bottom');
  }

  get background_image() {
    if (!this.props.backgroundImage) return undefined;
    return `url(https://ik.imagekit.io/spotlio/fetch/tr:w-1920/https://${getImageDeliveryUrl()}/${this.props.backgroundImage})`
  }

  get mobile_bg_image(){
    if (!this.props.mobileBackgroundImage) return undefined;
    return `url(https://ik.imagekit.io/spotlio/fetch/tr:w-660/https://${getImageDeliveryUrl()}/${this.props.mobileBackgroundImage})`
  }

  get rounded() {
    if(this.props.roundedCorners) return "rounded-2xl";
    return "";
  }

  getBackgroundImageAndOverlayStyles(){
    const isMobile = isRunTime() && window.matchMedia('(max-width: 640px)').matches; // Adjust breakpoint as per `sm`

    let styles = "";
    if (!this.background_image && !this.mobile_bg_image) return this.props.backgroundColor || "";
    if(isMobile) styles += this.mobile_bg_image || this.background_image
    else styles += this.background_image || this.mobile_bg_image
    if(this.overlayColor) styles += `, linear-gradient(${this.overlayColor},${this.overlayColor})`
    return styles;
  }

  get overlayColor (){
    return this.props.overlayColor || "";
  }

  get overlayStyle(){
    if(this.overlayColor) return `, linear-gradient(${this.overlayColor},${this.overlayColor})`
  }

  get id() {
    if (this.props.anchor) return this.props.anchor;
    if (this.props.name) return slugify(this.props.name);
    return undefined;
  }

  getStyle() {
    const outterStyles = this.props.style || {};
    const stylevars: any = {
      ...outterStyles,
      background: this.getBackgroundImageAndOverlayStyles(),
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundBlendMode: "overlay",
    }
    if (stylevars.background === "" || !stylevars.background) delete stylevars.background;
    return stylevars;
  }

  render() {
    const hasBackgroundImage = this.background_image || this.mobile_bg_image;
    const divProps = hasBackgroundImage && this.props.ariaLabel ? {
      role: 'img' as const,
      'aria-label': this.props.ariaLabel,
    } : {};
    
    return (
      <div
        className={`mx-0 my-0 ${this.padding_top} ${this.padding_bottom} ${this.props.className} ${this.rounded}`}
        id={this.id}
        style={this.getStyle()}
        {...divProps}
      >
        {this.props.children}
      </div>
    )
  }
}


